export default __webpack_public_path__ + "static/media/Premier.0624ff95.png";